import api from "./api";

// Calendar setup against ProfessionalDetails / MasterCalendar (if still used elsewhere)
export const getCalendarSetup = () => {
  return api.get("/user/calendar-setup");
};

export const saveCalendarSetup = (calendar_uid) => {
  return api.post("/user/calendar-setup", { calendar_uid });
};

// Google calendars: list and save selected calendar IDs for the authenticated user
export const listGoogleCalendars = () => {
  return api.get("/oauth/google/calendars");
};

export const saveGoogleCalendars = (calendar_ids) => {
  return api.post("/oauth/google/calendars", { calendar_ids });
};

// Microsoft calendars: list and save selected calendar IDs for the authenticated user
export const listMicrosoftCalendars = () => {
  return api.get("/oauth/microsoft/calendars");
};

export const saveMicrosoftCalendars = (calendar_ids) => {
  return api.post("/oauth/microsoft/calendars", { calendar_ids });
};

// Apple calendars: connect, list, save selected calendar IDs
export const connectAppleCalendar = (payload) => {
  return api.post("/apple/connect", payload);
};

export const listAppleCalendars = () => {
  return api.get("/apple/calendars");
};

export const saveAppleCalendars = (calendar_ids) => {
  return api.post("/apple/calendars", { calendar_ids });
};

// inspection only, no changes
export const uploadCalendarFile = (file) => {
  return api.post("/user/calendar/upload", { file });
};
